import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'
import Button from 'srcReact/components/common2/Button'
import Modal from 'srcReact/components/common2/Modal'

function MemberAlreadyExistInWPPopin({ isOpen, closeModal, emails }) {
  const { t } = useTranslation()

  return (
    <Modal
      isOpen={isOpen}
      handleClose={closeModal}
      title={
        emails?.length === 1
          ? t('workplace.invite_members.existingEmailError')
          : t('workplace.invite_members.existingEmailErrorPlural')
      }
      titleCSS={styles.title}>
      <div className={styles.emails}>
        {emails?.map((email) => (
          <div className={styles.email}>{email}</div>
        ))}
      </div>
      <Button text={t('global.ok')} className={styles.okButton} handleClick={closeModal} />
    </Modal>
  )
}

export default MemberAlreadyExistInWPPopin
